import { createContext, useContext, useRef, ReactNode, FC } from 'react';
import { uidSeed, UIDType } from './uid';

let loggedWarning = false;

const UIDContext = createContext<UIDType | null>(null);
export type UID = string | null;

// IGNORE PREFIX
// only pass a prefix if you’re calling more than one root renderer (hydrateRoot or root.render)

export const UIDProvider: FC<{ prefix?: string }> = ({ prefix, children }) => {
    const generateUID = useContext(UIDContext);
    if (!generateUID) {
        return <UIDContext.Provider value={uidSeed(prefix)}>{children}</UIDContext.Provider>;
    }

    // eslint-disable-next-line no-console
    console.warn(`dibs-uid | UID provider already exists, ignoring this provider instance`);

    // if provider already exists, pass the value down
    return <UIDContext.Provider value={generateUID}>{children}</UIDContext.Provider>;
};

export const useUID = (): UID => {
    const generateUID = useContext(UIDContext);
    if (!generateUID && !loggedWarning) {
        loggedWarning = true;
        // eslint-disable-next-line no-console
        console.warn('dibs-uid | UID consumer does not have a provider');
    }
    const uidRef = useRef(generateUID ? generateUID() : null);
    return uidRef.current;
};

export const UIDConsumer: FC<{ children: (uid: UID) => ReactNode }> = ({ children }) => {
    const uid = useUID();
    return <>{children(uid)}</>;
};
